module.exports = __webpack_public_path__ + "static/media/perimetre.df1ebeb3.png";